// Invite-code plumbing for the invite-only sign-up (HOP-33 enforcement).
//
// The code validated on /auth/signup is stashed in sessionStorage so it
// survives the Auth0 redirect (same tab) and can be presented to
// POST /api/users/sync, which consumes it server-side when creating the
// account. The backend refuses to create a user for a new Auth0 identity
// without a valid unused code (403 INVITE_REQUIRED).

export const INVITE_CODE_KEY = 'hopscotch.invite_code'

// Set after any successful sync; deliberately survives logout (unlike the
// zustand store) so a returning browser lands on /auth/login ("Good to see
// you") while a brand-new visitor lands on the invite-gated /auth/signup.
export const KNOWN_ACCOUNT_KEY = 'hopscotch.known_account'

export function stashInviteCode(code: string) {
  sessionStorage.setItem(INVITE_CODE_KEY, code)
}

export function readInviteCode(): string | null {
  return sessionStorage.getItem(INVITE_CODE_KEY)
}

export function clearInviteCode() {
  sessionStorage.removeItem(INVITE_CODE_KEY)
}

export function markKnownAccount() {
  try {
    localStorage.setItem(KNOWN_ACCOUNT_KEY, '1')
  } catch {
    // Storage unavailable (private mode quirks) — routing just defaults to
    // the signup front door next visit.
  }
}

export function hasKnownAccount(): boolean {
  try {
    return localStorage.getItem(KNOWN_ACCOUNT_KEY) === '1'
  } catch {
    return false
  }
}
